import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from '../../../i18n/use-translation';
import { harakiri } from '../../utils/harakiri.utils';
import { LoadingDots } from '../LoadingDots/LoadingDots';
import {
  captureExchangeEvent,
  hasCapturedFailure,
} from '../../utils/analytics/analytics.utils';
import { ExchangeEvent } from '../../utils/analytics/events';

const COUNTDOWN_SECONDS = 10;

type ClosingCountdownProps = {
  reason: 'success' | 'failure' | 'already-installed';
};

export const ClosingCountdown = ({ reason }: ClosingCountdownProps) => {
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(COUNTDOWN_SECONDS);
  const hasClosedRef = useRef(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountdown(prev => prev - 1);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (countdown !== 0 || hasClosedRef.current) {
      return;
    }
    hasClosedRef.current = true;

    // sendBeacon so the event survives closeExtension() and the SIGKILL that
    // follows it.
    captureExchangeEvent(
      ExchangeEvent.AutoClosed,
      {
        reason,
        seconds_visible: COUNTDOWN_SECONDS,
        installer_launched: reason === 'success',
        failure_reported: hasCapturedFailure(),
      },
      { useBeacon: true }
    );

    void harakiri();
  }, [countdown, reason]);

  return (
    <div>
      {t('closingCountdown', { count: countdown })}
      <LoadingDots />
    </div>
  );
};
